import gql from 'graphql-tag';

export const getRegions = gql`
  query getRegions {
    getRegions {
      id
      name
    }
  }
`;
